import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'excelExport';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const excelExportActions = { ...slice.actions, ...extraActions };
export const excelExportReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        excelExport: {},
        //dashboardArgs: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/dashboard`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (postData)  => await fetchWrapper.post(`${baseUrl}/ExportTransactionsToExcel`, {postData})
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.excelExport = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.excelExport = action.payload;
                // state.dashboardArgs = action.meta.arg;                
            },
            [rejected]: (state, action) => {
                state.excelExport = { error: action.error };
            }
        };
    }
}
